exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".activeButton-bc114265{color:#f70 !important}\n", ""]);

// Exports
exports.locals = {
	"activeButton": "activeButton-bc114265"
};